module.exports = {
          srcSet: __webpack_public_path__ + "88658b7d73857e376f4a2f68ffe1ebdc-2384.png"+" 2384w",
          images:[ {path: __webpack_public_path__ + "88658b7d73857e376f4a2f68ffe1ebdc-2384.png",width: 2384,height: 2182}],
          src: __webpack_public_path__ + "88658b7d73857e376f4a2f68ffe1ebdc-2384.png",
          toString:function(){return __webpack_public_path__ + "88658b7d73857e376f4a2f68ffe1ebdc-2384.png"},
          
          width: 2384,
          height: 2182
        }